export enum DocumentType {
    ANIMATION = 'animation',
    PROJECT = 'project',
    ASSET = 'asset',
    TEMPLATE = 'template',
    CLIENT = 'client',
    CREATIVE = 'dynamic',
    DEFAULT = 'document',
    AD = 'ad',
    COMMENT = 'comment',
    TEARSHEET = 'tearsheet',
    TEARSHEET_AD = 'tearsheetAd',
    BUNDLE = 'bundle',
    BUNDLE_ELEMENT = 'bundleElement',
    BREADCRUMB = 'breadcrumb',
    USER = 'user',
    VIDEO_BUNDLE = 'videoBundle',
    VIDEO_BUNDLE_ELEMENT = 'videoBundleElement',
    NONE = '',
}
